import React from 'react';
import PropTypes from 'prop-types';

import {Box, TextField} from 'views/components';
import {translate} from 'views/module';

const EmailInput = (props) => {
  const {questionData, value, onChange} = props;

  return (
    <Box>
      <TextField
        fullWidth
        type='email'
        placeholder={questionData?.placeholder || translate('form.IntakeForms.Contact.Questions.Email.Placeholder')}
        value={value}
        onChange={onChange}
        helperText={questionData.helpText}
        slotProps={{
          htmlInput: {
            inputMode: 'email',
            autoComplete: 'email',
          },
          input: {
            sx: {
              borderRadius: '12px',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '150%',
            },
          },
        }}
      />
    </Box>
  );
};

EmailInput.propTypes = {
  questionData: PropTypes.shape({
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
  }).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EmailInput;
